import React from 'react'
import {
    FormLabel,
    HStack,
    useRadioGroup,
    Text,
    Checkbox
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {RoundDotIcon} from '../icons'

const RadioContainer = ({options, value, name, onChange, radioStyles = {}}) => {
    const {getRootProps, getRadioProps} = useRadioGroup({
        name,
        value: value,
        onChange: (val) => {
            onChange(val)
        }
    })

    const group = getRootProps()
    return (
        <HStack {...group}>
            {options.map(({label, value}) => {
                const radio = getRadioProps({
                    value: value?.toString()
                })

                return (
                    <FormLabel
                        key={value}
                        display="flex"
                        alignItems="center"
                        gap="6px"
                        marginRight="14px"
                    >
                        <Checkbox
                            onChange={radio.onChange}
                            isChecked={radio.isChecked}
                            value={radio.value}
                            iconColor="white"
                            iconSize="14px"
                            icon={<RoundDotIcon boxSize="10px" />}
                            sx={{
                                '.chakra-checkbox__control': {
                                    borderRadius: 'full',
                                    _checkedAndChild: {
                                        transform: 'translateY(0.1em)'
                                    },
                                    border: '1px solid',
                                    borderColor: 'black !important',
                                    backgroundColor: 'white !important',
                                    background: 'white !important',
                                    outline: 'none',
                                    _hover: {
                                        backgroundColor: 'white !important'
                                    }
                                }
                            }}
                        >
                            <Text fontWeight="400" sx={radioStyles}>
                                {label}
                            </Text>
                        </Checkbox>
                    </FormLabel>
                )
            })}
        </HStack>
    )
}

RadioContainer.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
                .isRequired,
            height: PropTypes.string,
            width: PropTypes.string
        })
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    radioStyles: PropTypes.object
}

export default RadioContainer
